// extracted by mini-css-extract-plugin
export default {"root":"MeetingsPage_root__jZDp0","header":"MeetingsPage_header__bGQVA","spinner":"MeetingsPage_spinner__gcELu"};